import PropTypes from 'prop-types'

import groupShape from './groupShape'
import placeShape from './placeShape'

export default PropTypes.shape({
  groups: PropTypes.arrayOf(groupShape),
  selectedPlace: placeShape,
  totalCount: PropTypes.number,
  volumeSet: groupShape,
  whatFacets: PropTypes.arrayOf(
    PropTypes.shape({
      count: PropTypes.number,
      id: PropTypes.string,
      name: PropTypes.string,
      primaryId: PropTypes.number,
      relatedId: PropTypes.number,
    })
  ),
  whereFacets: PropTypes.arrayOf(
    PropTypes.shape({
      count: PropTypes.number,
      place: placeShape,
    })
  ),
})
